import ModelEntity from "../model-entity"
import {EntityType} from "../../gd/const/item"
import {SpaceProto} from "../space/space-proto";

export default class StarredItem extends ModelEntity {

    public taskId       : ID
    public projectId    : ID
    public companyId    : ID

    private _space?       : SpaceProto
    // public project?     : ProjectSession

    constructor(data: any) {
        super(data['id'], EntityType.DYNAMIC_MODEL)

        this.taskId     = data.taskId
        this.projectId  = data.projectId
        this.companyId  = data.companyId

    }

    get space():SpaceProto | undefined {

        if (this._space) {
            return this._space
        }

        //
        if (this.projectId) {

            const project = gd.session.projects.get(this.projectId) || undefined

            if (!project) {
                // console.error("#938747jd No project found for this starred item - how come ?")

                // koroche - vo pervih stars so vseh orgs ... potomu cghto netu companyId v star yet
                // tak chto poka netu smisla error pokazivat' tut

            } else {
                this._space = project.workspace || gd.spaces.projects
            }

        }

        return this._space

    }
}